import React, { ReactNode } from "react";
import Button from "@components/button/Button";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";
import { X } from "lucide-react";

interface ModalProps {
  className?: string;
  showModal?: boolean;
  botaoExcluir?: boolean;
  setShowModal?: (value: boolean) => void;
  width?: string;
  height?: string | null;
  title?: string;
  children?: ReactNode;

  // Button 001
  button001_Nome?: string;
  button001_onClick?: () => void;
  showButton001?: boolean;
  button01_classname?: string;

  // Button 002
  button002_Nome?: string;
  button002_onClick?: () => void;
  showButton002?: boolean;
  button02_classname?: string;
}

const NewModal: React.FC<ModalProps> = ({
  className = "",
  showModal = false,
  botaoExcluir = true,
  setShowModal = () => {},
  width = "",
  height = null,
  title = "",
  children,

  // Button 001
  button001_Nome = "Sim",
  button001_onClick = () => {},
  showButton001 = false,
  button01_classname = "",

  // Button 002
  button002_Nome = "Não",
  button002_onClick = () => {},
  showButton002 = false,
  button02_classname = "",
}) => {
  if (!showModal) return null;

  return (
    <div
      className={`position-fixed top-0 left-0 w-full h-full bg-black/50 flex items-center justify-center z-50 ${className}`}
    >
      <div
        className="bg-card text-primary-tail-foreground rounded-lg p-3 shadow-lg border-1 border-border-tail hover:border-border/80"
        style={{
          width,
          ...(height && { height }),
          maxWidth: "calc(100% - 20px)",
        }}
      >
        <div className="mb-3 flex justify-between items-center">
          {title && <p>{title}</p>}

          {botaoExcluir && (
            <X
              className="h-4 w-4 cursor-pointer hover:text-primary-tail text-muted-foreground"
              onClick={() => {
                setShowModal(false);
              }}
            />
          )}
        </div>

        <div className="body">{children}</div>

        <div className="modal-button">
          {showButton001 && (
            <Button
              className={button01_classname}
              nome={button001_Nome}
              onClick={button001_onClick}
            />
          )}

          {showButton002 && (
            <Button
              className={button02_classname}
              nome={button002_Nome}
              onClick={button002_onClick}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default NewModal;
